/** Query keys: ['console', resource, ...params]. Invalidate by prefix. */
export const ck = {
  all: ['console'] as const,
  dashboard: ['console', 'dashboard'] as const,
  sessions: ['console', 'sessions'] as const,
  lots: ['console', 'lots'] as const,
  exceptions: ['console', 'exceptions'] as const,
  payouts: ['console', 'payouts'] as const,
  farmers: ['console', 'farmers'] as const,
  rateCards: ['console', 'rate-cards'] as const,
  sackTypes: ['console', 'sack-types'] as const,
  yieldCaps: ['console', 'yield-caps'] as const,
  equipment: ['console', 'equipment'] as const,
  yieldBands: ['console', 'yield-bands'] as const,
  steps: ['console', 'steps'] as const,
  devices: ['console', 'devices'] as const,
  receiptBooks: ['console', 'receipt-books'] as const,
  rolls: ['console', 'rolls'] as const,
  qrGeneration: ['console', 'qr-generation'] as const,
  locations: ['console', 'locations'] as const,
  stock: ['console', 'stock'] as const,
  shipments: ['console', 'shipments'] as const,
  samples: ['console', 'samples'] as const,
  declarations: ['console', 'declarations'] as const,
  reference: ['console', 'reference'] as const,
  media: ['console', 'media'] as const,
  pack: ['console', 'pack'] as const,
  quality: ['console', 'quality'] as const,
}
